const BREAKPOINTS = {
    showHamburger: 1050,
    showListView: 1460,
}

export default BREAKPOINTS